import { render, staticRenderFns } from "./Redpack.vue?vue&type=template&id=a3c6128e&scoped=true&"
import script from "./Redpack.vue?vue&type=script&lang=js&"
export * from "./Redpack.vue?vue&type=script&lang=js&"
import style0 from "./Redpack.vue?vue&type=style&index=0&id=a3c6128e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c6128e",
  null
  
)

export default component.exports